/**
 * Estilos compartidos de la burbuja de chat.
 *
 * Vive aparte del componente porque `react-refresh/only-export-components`
 * no permite exportar helpers no-componente desde un archivo de componente
 * (y el lint del proyecto corre con `--max-warnings 0`).
 */

import type { Theme } from '@mui/material/styles';

/**
 * Fondo de la burbuja del agente.
 *
 * NO usar `grey.100` directamente: en MUI `grey` es una escala fija que no
 * cambia con el modo, así que en dark quedaba un fondo casi blanco con texto
 * casi blanco (contraste 1.04:1 → invisible).
 */
export const agentBubbleBg = (theme: Theme) =>
  theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100';
